import React from 'react';
import ReactHOC from '../../../../common/react-hoc';
import { FlexComponentBootstrap } from "../../../../common/component-bootstraper";

class SideAccordionImageSpotApp extends React.Component {

  constructor(props) {
    super(props);

    this.imageSpotList = this.props.settings.imageSpotList;

    this.state = {
      activeIndex: 0,
      animate: false
    };
  }

  checkIfElementHasContent(el) {
    const withoutSpace = el.trim().replace('&nbsp;','');
    return withoutSpace.length > 0;
  }

  handleItemClick(index) {
    if (index !== this.state.activeIndex) {
      this.setState({activeIndex: index, animate: true});
    }
    if (index === this.state.activeIndex && !this.props.isDesktop) {
      this.setState({activeIndex: null});
    }
  }

  handleItemKeyPress(e, index) {
    if (e.keyCode === 13) {
      this.handleItemClick(index);
    }
  }

  getContent() {
    if (this.state.activeIndex === null) {
      return null;
    }
    const activeItem = this.imageSpotList[this.state.activeIndex];
    return (
      <div className="content">
        <div
          className={`content__item ${this.state.animate ? 'animate' : ''}`}
          onAnimationEnd={() => this.setState({ animate: false })}>
          {
            this.props.isDesktop &&
            activeItem.header &&
            this.checkIfElementHasContent(activeItem.header) &&
            <div className="content__item__title" dangerouslySetInnerHTML={{__html: activeItem.header}} />
          }
          {
            activeItem.text &&
            this.checkIfElementHasContent(activeItem.text) &&
            <div className="content__item__text" dangerouslySetInnerHTML={{__html: activeItem.text}} />
          }
        </div>
      </div>
    );
  }

  render() {
    const { isDesktop } = this.props;
    return (
      <React.Fragment>
        <ul className="nav">
          {this.imageSpotList.map((item, index) => {
            const isExpanded = this.state.activeIndex === index;
            return (
              <li
                className={`nav__item ${isExpanded ? 'active' : ''}`}
                key={index}
                role="button"
                tabIndex="0"
                aria-expanded={isExpanded}
                onClick={() => this.handleItemClick(index)}
                onKeyDown={(e) => { this.handleItemKeyPress(e, index) }}
              >
                {
                  item.header &&
                  this.checkIfElementHasContent(item.header) &&
                  <div
                    className="nav__item__title"
                    dangerouslySetInnerHTML={{__html: item.header}}
                  />
                }
                {!isDesktop && isExpanded && this.getContent()}
              </li>
            )
          })}
        </ul>
        {isDesktop && this.getContent()}
      </React.Fragment>
    )
  }
}

const sideAccordionImageSpot = new FlexComponentBootstrap('image-spot', '.side-accordion');
sideAccordionImageSpot.reactApp = ReactHOC(SideAccordionImageSpotApp);
sideAccordionImageSpot.run();
